import React from 'react';

import { getSize, Size } from './utils';

interface Props {
    type: 'next' | 'prev';
    size: Size;
    color?: string;
}

export const SwitchTrackIcon: React.FC<Props> = ({ type, size, color = '#696969' }) => {
    const sizePx = getSize(size);

    const style: React.CSSProperties | undefined =
        type === 'prev'
            ? {
                  transform: 'rotate(180deg)',
                  transformOrigin: '50% 50%',
              }
            : undefined;

    return (
        <svg
            width={sizePx}
            height={sizePx}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.208 9.647L4 11.517V4.483l3.208 1.871A20 20 0 009.939 7.68l.811.32-.811.32c-.943.373-1.856.816-2.731 1.327zm-3.704-7.77A1 1 0 002 2.741v10.518a1 1 0 001.504.864L12 9.167v3.836a1 1 0 002 0v-10a1 1 0 00-2 0v3.83L3.504 1.877z"
                fill={color}
                strokeWidth="1"
            />
        </svg>
    );
};
